export default "__VITE_ASSET__B9nh81Bs__"